exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.checklist-detail-enter-active[data-v-0753be8d],\n.checklist-detail-leave-active[data-v-0753be8d] {\n  transition: all 0.4s ease-out;\n}\n.checklist-detail-enter-to[data-v-0753be8d],\n.checklist-detail-leave[data-v-0753be8d] {\n  max-height: 100vh;\n}\n.checklist-detail-enter[data-v-0753be8d],\n.checklist-detail-leave-to[data-v-0753be8d] {\n  max-height: 0px;\n}\n", ""]);

// exports
